var _rect, _rect2, _path;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgFlagRed(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 20,
    height: 20,
    viewBox: "0 0 20 20",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    x: 4.67383,
    y: 1.66675,
    width: 2.02899,
    height: 16.6667,
    rx: 1,
    fill: "#FF5E5E"
  })), _rect2 || (_rect2 = /*#__PURE__*/React.createElement("rect", {
    x: 4.16699,
    y: 1.66675,
    width: 3.04348,
    height: 1.5625,
    rx: 0.78125,
    fill: "#FF5E5E"
  })), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M14.7134 7.00966C15.4853 7.36802 15.4853 8.46532 14.7134 8.82368L6.42144 12.6735C5.75862 12.9813 5.00033 12.4973 5.00033 11.7665L5.00033 4.06681C5.00033 3.33604 5.75862 2.85207 6.42144 3.1598L14.7134 7.00966Z",
    fill: "#FF5E5E"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgFlagRed);
export default __webpack_public_path__ + "static/media/flagRed.4e2b525e9d70c0eba9b4b9a1c8abfeb0.svg";
export { ForwardRef as ReactComponent };